/* eslint-disable  func-names */
/* eslint-disable  no-restricted-syntax */
/* eslint-disable  no-loop-func */
/* eslint-disable  consistent-return */
/* eslint-disable  no-console */
/* eslint-disable max-len */
/* eslint-disable prefer-destructuring */

module.exports = {
	//Staging
  //API_URL: 'https://3k26bpekzl.execute-api.us-east-1.amazonaws.com/Prod',
	//Production
  API_URL: 'https://7gg8d9krql.execute-api.us-east-1.amazonaws.com/Prod',
  REGEX_API_URL: 'https://yureh6zbq2.execute-api.us-east-1.amazonaws.com/Prod',
  //REGEX_API_URL: 'https://c22zajmne0.execute-api.us-east-1.amazonaws.com/Prod/',
  SEARCH_TYPES:[
     "SINGLE_SEARCH",
     "MULTI_SEARCH"
  ],
  LANGUAGE_CODES:[
     "DE",
     "EN",
     "IT",
     "FR",
	 "ZH",
	 "ES",
	 "PT"
  ],
  DATASOURCES:[
	"pressrelations-daily",
	"OPOINT",
  "PMG",
	"APA",
	"other",
	"CLIENT_OERK_OWNED",
	"CLIENT_OERK_TV",
	"CLIENT_OERK_PRINT"
  ],
  COUNTRY_CODES_ENTITIES:[
     "DE",
     "AT",
     "IT",
     "CH",
     "FR",
     "EN",
	 "PT",
	 "ES"    
  ],
  COUNTRY_CODES_SEARCHES:[
     "DE",
     "AT",
     "IT",
     "CH",
	 "PT"
  ],
  COUNTRY_EXCLUSION_CODES:[
     "DE",
     "AT",
     "IT",
     "DE_AT" 
  ],
  SPECIAL_EXCLUSION_CODES:[
     "DEFAULT",
     "DE_IMMOBILIEN"
  ],
  CUSTOMERS: [
      'IMWF',
      'BSH'],
  STUDIES_PROJECTS: [
    'ALLGEMEIN',
    'ARAG',
    'AUTOMOTIVE',
    'AXIANS',    
    'BANKEN',
    'BUNDESBEHOERDE',
    'BWI',
    'CARGLASS',
    'CONCARDIS',
    'CREDIT_RATING',
    'CSC_EXTENDED_PROTECTION',
    'HAMBURG_STUDIE', 
    'INSURANCE',
    'JTI',
    'KLINIKEN',
    'KRANKENKASSEN',
    'LIEBHERR',
    'PHARMAKONZERNE',    
    'PRONOVA', 
    'PRUEFGESELLSCHAFT',
    'ROLANDBERGER',
    'STROM',
    'TELEFONICA',
    'VALIDIERUNGSSTUDIE',
    'VNG-STUDIE',
    'ZURICH'
  ],
  ENTITY_TAGS: [
    'a3Bau',
    'Akima',
    'Aktivismus',
    'ASKSOPHIE_BANKENFELD',
    'ASKSOPHIE_GENOBANKEN',
    'ASX',
    'AT_Immobilien',
    'AT_MARKEN',
    'Bankenstudie',
    'Begehrteste_Produkte',
    'Begehrteste_Prod_Reduced',
    'BERATUNGSFIRMEN',
    'BOVESPA',
    'BUNDESLIGA',
    'CAC40',
    'CELEBRITIES',
    'CGM_MARKEN',
    'CLEAN',
    'CSC',
    'Dashboard',
    'DAX',
    'DE_zu_AT',
    'DOW_JONES',
    'deepdigital',
    'ENGLISH',
    'ENTITIES_WITH_NAME_RULE',
    'ENTITIES_WITH_LAST_NAME_RULE',
    'ENTITIES_WITH_SPECIAL_EVENTTYPES',
    'ENTITIES_WITH_SPECIAL_RULE',
    'EURO_STOXX',
    'FAMILIENUNTERNEHMEN',
    'FINANZDIENSTLEISTER',
    'FLOTTENMANAGEMENT',
    'FTSE100',
    'FMCG-HAENDLER',
    'FMCG-MARKEN',
    'FRANCHISE',
    'Genossenschaften',
    'GESUNDHEITSWESEN',
    'HANG_SENG',
    'IBEX35',
    'Industriereputation',
    'INTERNAL',
    'INTERNATIONAL_ENTITIES',
    'ITALIEN',
    'IT_CHAMPIONS',
    'IT_CloudMigration',
    'IT_DataServices',
    'IT_Enterprise_Storage',
    'IT_ERP-Anbieter',
    'IT_Networking',
    'IT_SECURITY',
    'Klinikstudie',
    'KUNUNU_DATA',
    'LADESTATIONEN',
    'LOCAL_ENTITIES',
    'Marke',
    'MESSEN',
    'MOEBELSTUDIE',
    'MUETTER',
    'NASDAQ',
    'NEU',
    'NIKKEI',
    'NGO',
    'NGO_AT',
    'NO_SLA',
    'OESTERREICH',
    'OESTERREICH_BASIS',
    'OESTERREICH_PROJEKT',
    'PERSON',
    'POLITIKER',
    'Produktstudie',
    'PROBLEM',
    'RAX_DAX',
    'RAX_MDAX',
    'RAX_SDAX',
    'RAX_TecDAX',
    'RTS',
    'SCHWEIZ',
    'Selbstbestimmtes_Leben',
    'SENSEX',
    'SMARTHOME',
    'SMI',
    'Sparkassen',
    'SPECIAL_EXCLUSION',
    'STADTWERKE',
    'STRAITS_TIMES',
	'SV-EXKLUSIV',
    'S&P100',
    'S&P500',
    'S&P/TSX',
    'TAG_B2B',
    'TAG_B2C',
    'TEST-ENTITIES',
    'THEMENSUCHE',
    'TIERE',
    'TOP1000',
    'TOP5000',
    'TOP20000',
	'TRANSLATE_INTO_ENGLISH',
    'TWITTER_AUTHOR',
    'Verband',
    'Vermoegensverwalter',
    'VORSTAENDE',
    'Wahl_22',
    'Wichtige_Politiker'
    ],

  EVENT_TYPES: [
    'DE_ASSORTMENT_SENTENCES',
    'DE_ANALYSTEN_SENTENCES',
    'DE_BEST_VALUE_FOR_MONEY_SENTENCES',
    'DE_CAREER_SENTENCES',
    'DE_CAREER_START_SENTENCES',
    'DE_COMPANY_CULTURE_SENTENCES',
    'DE_CUSTOMER_ADVICE_SENTENCES',
    'DE_CUSTOMER_SATISFACTION_SENTENCES',
    'DE_CYBER_ATTACK_SENTENCES',
    'DE_CYBER_ATTACK_MITIGATED_SENTENCES',
    'DE_CSC_CYBERSECURITY_SENTENCES',
    'DE_DATA_BREACH_SENTENCES',
    'DE_DESIRE_SENTENCES',
    'DE_DIGITIZATION_SENTENCES',
    'DE_EMOTIONALITY_SENTENCES',
    'DE_EMPLOYER_FAIRNESS_SENTENCES',
    'DE_EMPLOYER_SENTENCES',
    'DE_EMPLOYER_SENTENCES_REGEX',
    'DE_EMPLOYER_SENTENCES_REGEX_TEST',
    'DE_EQUALITY_SENTENCES',
    'DE_EX_EMPLOYEE_SENTENCES',
    'DE_FAIRNESS_SENTENCES',
    'DE_FUN_SENTENCES',
    'DE_HAPPINESS_SENTENCES',
    'DE_HOBBY_SENTENCES',
    'DE_INDIVIDUALITY_SENTENCES',
    'DE_INNOVATION_SENTENCES',
    'DE_INSOLVENCY_SENTENCES',
    'DE_INSOLVENCY_TEST_SENTENCES',
    'DE_INTEGRITY_SENTENCES',
    'DE_INVESTMENT_SENTENCES',
    'DE_MANAGEMENT_SENTENCES',
    'DE_MANAGEMENT_SENTENCES_REGEX',
    'DE_MERGER_SENTENCES',
    'DE_NETZE_SENTENCES',
    'DE_PRICING_SENTENCES',
    'DE_PRIDE_SENTENCES',
    'DE_PRODUCT_NEWS_SENTENCES',
    'DE_PRODUCT_SERVICE_SENTENCES',
    'DE_PRODUCT_SERVICE_SENTENCES_REGEX',
    'DE_PROFITABILITY_SENTENCES',
    'DE_PROFITABILITY_SENTENCES_REGEX',
    'DE_QUALITY_SENTENCES',
    'DE_RECOMMENDATION_SENTENCES',
    'DE_RESEARCH_AND_DEVELOPMENT_SENTENCES',
    'DE_SALARY_SENTENCES',
    'DE_SERVICE_SENTENCES',
    'DE_SUSTAINABILITY_SENTENCES',
    'DE_SUSTAINABILITY_SENTENCES_REGEX',
    'DE_TECHNOLOGY_SENTENCES',
    'DE_TRUST_V2_SENTENCES',
    'DE_WORKING_CLIMATE_SENTENCES',
    'DE_SOCIAL_SUSTAINABILITY_SENTENCES_REGEX',
    'DE_ECONOMIC_SUSTAINABILITY_SENTENCES_REGEX',
    'DE_ENVIRONMENTAL_SUSTAINABILITY_SENTENCES_REGEX',
    'DE_GENDER_SHIFT_SENTENCES_REGEX',
    'DE_HEALTH_SENTENCES_REGEX',
    'DE_GLOBALIZATION_SENTENCES_REGEX',
    'DE_INDIVIDUALIZATION_SENTENCES_REGEX',
    'DE_CONNECTIVITY_SENTENCES_REGEX',
    'DE_MOBILITY_SENTENCES_REGEX',
    'DE_NEO_ECOLOGY_SENTENCES_REGEX',
    'DE_NEW_WORK_SENTENCES_REGEX',
    'DE_SAFETY_SENTENCES_REGEX',
    'DE_SILVER_SOCIETY_SENTENCES_REGEX',
    'DE_URBANIZATION_SENTENCES_REGEX',
    'DE_KNOWLEDGE_CULTURE_SENTENCES_REGEX',
    'DE_STUDY_SENTENCES',
    'DE_DATA_SECURITY_SENTENCES',
    'DE_DIGITAL_NATIVES_SENTENCES',
    'DE_WANTED_PRODUCTS_SENTENCES',
    'DE_HOTLINE_SENTENCES',
    'DE_FAMILY_FRIENDLY_SENTENCES',
    'DE_IT_SECURITY_SENTENCES',
    'DE_WANTED_PRODUCTS_SENTENCES',
    'DE_AUSTRIAN_REGIONALISM_SENTENCES',
    'DE_SWISS_REGIONALISM_SENTENCES',
    'EN_ANALYSTS_SENTENCES',
    'EN_BEST_VALUE_FOR_MONEY_SENTENCES',
    'EN_CYBER_ATTACK_MITIGATED_SENTENCES',
    'EN_CYBER_ATTACK_SENTENCES',
    'EN_CSC_CYBERSECURITY_SENTENCES',
    'EN_DATA_BREACH_SENTENCES',
    'EN_EMPLOYER_SENTENCES',
    'EN_EX_EMPLOYEE_SENTENCES',
    'EN_INNOVATION_SENTENCES',
    'EN_INTEGRITY_SENTENCES',
    'EN_MANAGEMENT_SENTENCES',
    'EN_PRIDE_SENTENCES',
    'EN_PRODUCT_SERVICE_SENTENCES',
    'EN_PROFITABILITY_SENTENCES',
    'EN_QUALITY_SENTENCES',
    'EN_SERVICE_SENTENCES',
    'EN_STUDY_SENTENCES',
    'EN_SUSTAINABILITY_SENTENCES',
    'FR_ANALYSTS_SENTENCES',
    'FR_BEST_VALUE_FOR_MONEY_SENTENCES',
    'FR_EMPLOYER_SENTENCES',
    'FR_INNOVATION_SENTENCES',
    'FR_INTEGRITY_SENTENCES',
    'FR_MANAGEMENT_SENTENCES',
    'FR_PRIDE_SENTENCES',
    'FR_PRODUCT_SERVICE_SENTENCES',
    'FR_PROFITABILITY_SENTENCES',
    'FR_QUALITY_SENTENCES',
    'FR_SERVICE_SENTENCES',
    'FR_SUSTAINABILITY_SENTENCES',
    'FR_SWISS_REGIONALISM_SENTENCES',
    'IT_CAREER_SENTENCES',
    'IT_COMPANY_CULTURE_SENTENCES',
    'IT_DIGITIZATION_SENTENCES',
    'IT_INNOVATION_SENTENCES',
    'IT_INSOLVENCY_SENTENCES',
    'IT_TECHNOLOGY_SENTENCES',
    'IT_WORKING_CLIMATE_SENTENCES',
    'IT_SUSTAINABILITY_SENTENCES',
    'IT_ECONOMIC_SUSTAINABILITY_SENTENCES',
    'IT_ENVIRONMENTAL_SUSTAINABILITY_SENTENCES',
    'IT_SOCIAL_SUSTAINABILITY_SENTENCES',
    'IT_EQUALITY_SENTENCES',
    'Logistik',
    'Verhalten',
    'Sprache',
    'Interne Kommunikation',
    'Action needed'
  ],
 INDUSTRIES_1: [
	'Agrarunternehmen',
	'Automobilmarkt',
	'Banken',
	'Bau',
	'Bauunternehmen',
	'Bauzubehör- und Stoffe',
	'Berufsleben',
	'Bestattung',
	'Bildung',
	'Celebrities',
	'Chemie',
	'Computer und Peripheriegeräte',
	'Dienstleister',
	'Dienstleistungen',
  'Drogerie & Medikamente',
	'Energie',
	'Finanzdienstleistung',
	'Finanzen',
	'Forschung und Entwicklung',
	'Freizeit, Sport & Hobbies',
  'Gebäudemanagement- und Sicherheitsdienste',
	'Genossenschaften',
	'Genossenschaften, Verbände und Vereine',
	'Gesundheit',
	'Gesundheit und Pharmazie',
	'Getränke',
	'Handel',
	'Haus und Garten',
  'Hersteller',
	'Hersteller von medizinischen Hilfsmitteln', 
	'Holding- und Beteiligungsgesellschaften',
	'Hotels und Gastronomie',
	'Immobilien',
	'Industrie',
	'ITK',
	'Körperpflege',
	'Kraftfahrzeug-Markt',
	'Krankenhäuser',
	'Kreditinstitute',
	'Landwirtschaft',
	'Lebensmittel',
  'Lebensmittel & Getränke',
	'Lederwaren',
  'Logistik',
	'Luftfahrt',
	'Medien',
	'Medizinische Einrichtungen',
	'Metallindustrie',
	'Möbel und Einrichtung',
	'Natur',
	'Öffentlicher Dienst',
	'Organisationen',
	'Personen',
	'Persönlicher Bedarf',
	'Politiker',
	'Rohstoffe',
	'Sozial- und Gesundheitswesen',
	'Sperrbranche',
	'Tabakwaren',
	'Telekommunikation',
	'Textilien und Bekleidung',
	'Touristik',
	'Unterhaltungselektronik',
	'Unternehmen',
	'Ver- und Entsorgung',
	'Verkehr und Logistik',
	'ZZ-Raus'
],
INDUSTRIES_2: [
	'Abwasserentsorgung',
	'Akustik',
	'Alkoholfreie Geränke',
	'Alkoholische Getränke',
	'Audiogeräte',
	'Ausgehen',
	'Autohändler',
	'Automobildienstleister',
	'Babypflege',
	'Bad und Sanitär',
	'Banken',
	'Bargeldlose Zahlungsmittel',
	'Batterien',
	'Bau',
	'Bauelemente',
	'Baufinanzierer',
	'Bauinstallation',
	'Bausparkassen',
	'Bauunternehmen',
	'Bauzubehör- und stoffe',
	'Bekannte Personen',
	'Bekleidung',
	'Beratungsdienste',
	'Bestattung',
	'Beteiligungsgesellschaft',
	'Bildungsdienstleister',
	'Brot und Dauerbackwaren',
	'Brotaufstriche',
  'Bundeskanzler/in',
	'Büro und Arbeitsalltag',
	'Carsharing-Anbieter',
	'Chemieunternehmen',
	'Chemische Produkte',
  'Cloud-Infrastruktur-Anbieter',
	'Computer',
	'Diäten- und Sportlernahrung',
	'Dienstleistung',
	'Dienstleistungen',
	'Druckdienstleister',
	'Einkaufsgenossenschaften',
	'Einzelhandel',
	'Elektrogeräte Haushalt',
	'Elektroindustrie',
	'Elektroinstallation',
	'Elektromobilität',
	'Elektrotechnik',
	'Energiedienstleister',
	'Energieversorgung',
	'Feinkosthändler',
	'Fertig- und Massivhaus-Anbieter',
	'Fertiggerichte',
  'Fertigprodukte',
	'Finanzberatung',
	'Finanzdienstleister',
	'Finanzdienstleistung',
	'Fintechs',
	'Fitnessstudios und Solarien',
	'Fleisch- und Fischwaren',
	'Flugzeugbauer',
	'Forschung und Entwicklung',
	'Forstwirtschaft',
	'Foto',
	'Freizeit, Sport & Hobbies',
	'Freizeitanlagen',
	'Fremdenverkehr',
	'Früchte und Gemüse',
	'Garten',
	'Gastronomie',
	'Gebäudemanagement- und Sicherheitsdienste',
	'Gebäudetechnik',
	'Gemeinnützige Krankenhäuser',
	'Genossenschaften',
	'Genossenschaften, Verbände und Vereine',
	'Geschenke',
	'Gesichts-, Haar- und Körperpflege und Kosmetik',
	'Gesundheit',
	'Gesundheit und Pharmazie',
  'Getränke',
	'Getränkeeinzelhandel',
	'Gewürze und Gewürzsaucen',
	'Glasindustrie',
	'Glücksspiel',
	'Großhandel',
	'Haarpflege',
	'Handel',
  'Hardware-Hersteller',
	'Haushalt',
	'Haushaltsartikel',
	'Heimdekoration',
	'Heimtextilien',
	'Hersteller von medizinischen Hilfsmitteln ',
	'Herstellung von Kraftwagen',
	'Hochschulen',
	'Holding',
	'Hotels',
	'Immobilien',
	'Immobilienentwickler',
	'Industrie',
	'Industriedienstleister',
	'Industriezulieferer',
	'Ingenieure',
	'Insurtechs',
	'Investmentgesellschaften',
  'IT-Berater',
	'IT- und Kommunikationsdienstleister',
	'IT-Dienstleister',
	'Kaffee, Tee, Kakao',
	'Keramikindustrie',
	'Kinos',
	'Kochboxen',
	'Kommunale Dientsleistungen',
	'Kommunikationsdienstleistungen',
	'Konserven',
	'Konsolen- und Pc-Spiele',
	'Körperhygiene',
	'Körperpflege',
	'Kraft- und Schmierstoffe',
	'Kraftfahrzeug-Markt',
	'Kraftfahrzeugteile',
	'Kraftstoffe',
	'Krankenhäuser',
	'Krankenkassen',
	'Kreditgenossenschaften',
	'Kreuzfahrten',
	'Küche',
	'Kunst und Kultur',
	'Laborunternehmen',
	'Lagereien',
	'Landwirtschaft',
	'Leasinggesellschaften',
	'Lebensmittel',
	'Lebensmitteleinzelhandel',
	'Lebensmittelproduktion',
	'Lederwaren',
	'Lichttechnik',
	'Lieferdienste',
	'Logistik',
	'Logistikunternehmen',
	'Luftfahrt',
	'Luxusmarken',
	'Maschinen- und Anlagenbau',
	'Maschinen- und Anlagenbauunternehmen',
	'Medien',
	'Medizinische Einrichtungen',
	'Medizintechnik',
	'Medizintechnikunternehmen',
	'Messen',
	'Metallverarbeitung',
	'Metallwaren',
	'Milchprodukte',
  'Minister/in',
	'Möbel und Einrichtung',
	'Möbelelemente',
	'Möbelhändler',
	'Möbelhersteller',
	'Mobilfunk',
	'Mobilitätsdienstleister',
	'Modelabels',
	'Modeunternehmen',
  'Molkeprodukte',
	'Mundpflege',
	'Münzen, Banknoten und Medaillen',
	'Musik',
	'Nährmittel',
	'Nahrungsergänzungsmittel und Vitaminpräparate',
	'Navigation',
	'Netzbetreiber',
	'NGO',
	'Oberflächen- und Materialbearbeitung',
	'Öffentliche Krankenhäuser',
	'Öffentlicher Dienst',
	'Öffentlich-rechtlichte Sparkassen',
	'Online-Dienstleistungen',
  'Online-Handel',
	'Online-Versandhändler',
	'Optik',
	'Optiker',
	'Optik und Akustik',
	'Papierverarbeiter',
	'Parfümerien',
	'Parfüms und Duftprodukte',
	'Parkhausbetreiber',
	'Parteimitglieder',
	'Peripheriegeräte',
	'Personaldienstleister',
	'Personen',
	'Pflege- und Gesundheitsprodukte',
	'Pharmaunternehmen',
	'Pharmazie',
	'Politiker',
	'Private Krankenhäuser',
	'Prüfgesellschaft',
	'Putz-, Pflege- und Waschmittel',
	'Raffination und Rohstoffgewinnung',
	'Rasierer und Zubehör',
	'Raumausstattung',
	'Rechtsdienstleistungen und -Anwälte',
	'Rohstoffe',
	'Rüstung',
  'Salzige Snacks',
	'Schifffahrt',
	'Schifffbauer',
	'Schirme',
	'Schreibgeräte',
	'Schuhe',
  'Service-Dienstleister',
  'Sicherheitstechnik',
	'Sicherungs- und Warngeräte',
	'Software- und Hardwareentwickler',
	'Solartechnik',
	'Sonstiger Fahrzeugbau',
	'Sozial- und Gesundheitsunternehmen',
	'Soziale Dienste',
	'Speditionen',
	'Speichermedien',
	'Speisefette und -öle',
	'Spezialbanken',
	'Spielzeug',
	'Sportgeschäfte',
	'Sport und Camping',
	'Stahlunternehmen',
	'Strassen- und Schienenverkehr',
	'Süßwaren',
	'Tabakwaren',
	'Taschen und Koffer',
	'Telekommunikation',
	'Textilbranche',
	'Textilvermieter',
  'Tiefkühlgerichte',
	'Tiefkühlkost',
	'Tierzubehör und -nahrung',
	'Touristik',
	'Transport- & Logistikunternehmen',
	'TV',
	'Uhren und Schmuck',
	'Unterhaltungselektronik',
	'Ver- und Entsorgung',
	'Veranstaltungen',
	'Verkehr und Logistik',
	'Verlage',
	'Vermögensverwalter',
	'Verpackungshersteller',
	'Versicherung',
	'Vorstände',
	'Waffen',
	'Wäsche',
	'Wasserentsorgung',
	'Wasserversorgung',
	'Weiterbildung',
	'Werkzeuge und Geräte',
	'Wohnwagen und Reisemobile',
	'Zusteller und Bringdienste',
	'Zweirad-Indsutrie',
	'ZZ-Raus'
],
INDUSTRIES_FINAL: [
	'Abbruchunternehmen',
	'Abrechnungsdienstleister',
	'Abschleppdienste',
	'Abwasserentsorgung',
	'Abwassergenossenschaften',
	'Accessoires',
	'AFD',
	'Agrarbusinessunternehmen',
	'Agrargenossenschaften',
	'Alkoholfreie Geränke',
  'alkoholische Getränke',
	'Aluminiumverarbeitung',
	'Ankaufportale',
	'Anlagenbauer',
	'Apotheken',
	'Arbeitnehmerüberlassung',
	'Arbeits- und Berufsbekleidungshersteller',
	'Arzneimittel',
	'Arzneimittelhersteller',
	'Audiogeräte',
	'Augenkliniken',
	'Autobanken',
	'Autobörsen',
	'Autoglasreparatur',
	'Autohändler',
	'Autolackierer',
	'Automatisierungs- und Systemtechnik',
	'Automobildienstleister',
	'Automobillogistikunternehmen',
	'Automobilsport',
	'Automobilzubehör',
	'Automobilzulieferer',
	'Autovermieter',
	'Autowaschanlagen',
	'Autowerkstätten',
	'Babyartikel',
	'Babynahrung',
	'Babypflege',
	'Bäckereien und Konditoreien',
  'Backwaren',
	'Badausstatter',
	'Bad-Shop',
	'Bad und Sanitär',
	'Bahnen',
	'Banken',
	'Barrierefreie Haushaltseinrichtungen',
	'Bastelzubehör',
	'Batterien',
	'Bauchemieunternehmen',
	'Bauelemente',
	'Baufinanzierer',
	'Baugenossenschaften',
	'Baugewerbe',
	'Baumärkte',
	'Bausparkassen',
	'Baustoffe und -zubehör',
	'Bauunternehmen',
	'Bauvereine',
	'Beauty- & Kosmetik-Shops',
	'Behindertengerechte Fahrzeugumbauten',
	'Bekannte Persönlichkeit (Sport/Medien)',
	'Bekleidungszubehör',
  'Berufsbekleidungshersteller',
	'Berufsgenossenschaftliche und Knappschafts-Kliniken',
	'Beschäftigungsförderungen',
	'Beschlaghersteller',
	'Bespielbare Bild- und Tonträger',
	'Bestattung',
	'Beteiligungsgesellschaften',
	'Beteiligungsgesellschaften (Nur eigenes Kapital)',
	'Betriebskrankenkassen',
	'Betten- und Zubehör-Shops',
	'Bettwarenhersteller',
	'Bettwäsche und -decken',
	'BG',
	'Biere',
	'Bildungsdienstleister',
	'Bildungseinrichtungen',
	'Bio- und Naturkost',
	'Bio- und Naturmärkte, Reformhäuser',
	'Biopharmazieunternehmen',
	'Biotechnologieunternehmen',
	'Blechherstellung- und verarbeitung',
	'Blumenhändler',
	'Blutspendedienste',
	'Bodenbelaghersteller',
	'Bonbons',
	'Bonussysteme',
	'Bordelle',
	'Börsen',
	'Bowlingcenter',
	'Brauereibedarf',
	'Brauereien',
	'Brauhäuser',
	'Brennereien',
	'Brillen und Hörgeräte',
	'Brillen und Kontaktlinsen',
	'Brot und Backwaren',
	'Brotaufstriche',
	'Brütereien',
	'Buchhändler',
	'Bundeswehrkrankenhäuser',
	'Bündnis 90/Die Grünen',
	'Burger-Restaurants',
	'Bürger in Wut',
	'Büroartikel',
	'Büroartikel- und Büromöbelgeschäfte',
	'Büromöbel',
	'Busunternehmen',
	'Cafés',
	'Callcenter-Betreiber',
	'Campingausstatter',
	'Carsharing-Anbieter',
	'Catering und Lebensmittellieferung',
	'CDU',
	'Chemieunternehmen',
  'Chips',
  'Cloud Infrastruktur & Hosting',
	'Clubanlagen',
	'Clubs und Diskotheken',
	'Coffee-Shops',
	'Computer- und Speichersystemhersteller',
	'Computer und Zubehör',
	'Convenience Shops',
	'Crowdfunding-Plattformen',
	'CSU',
	'Dachziegel und Dachzubehör',
	'Damenbekleidung',
	'Dentalunternehmen',
	'Depotbanken',
	'Diakonische Dienste',
	'Diakonische Kliniken',
	'Diätnahrung',
	'Die Linke',
	'Die PARTEI',
	'Digitale Finanz- / Versicherungsexperten',
	'Digital Marketing Agentur',
	'Direktbanken',
	'Direktversicherer',
	'Discounter',
	'Displayhersteller',
	'Dokumenten-Management-System-Anbieter (DMS)',
	'Drogeriemärkte',
	'Druckdienstleister',
	'Druckerhersteller',
	'Druckerzubehör',
	'Druckerzubehör-Shops',
	'Duty-Free Shops',
	'E-Bikes',
	'Edelstahlherstellung- und verarbeitung',
  'Edelmetalle, Münzen und Edelsteine',
	'Einkaufsgenossenschaften',
	'Einkaufsgenossenschaften im Handwerk',
	'Einkaufsgenossenschaften Landwirtschaft/Lebensmittel',
	'Einkaufszentren',
	'Einrichtungsgeschäfte',
	'Einzelhandel und Cash-And-Carry',
	'Einzelhändler',
	'E-Learning Anbieter',
	'Elektroautos',
	'Elektrofachgeschäfte',
	'Elektrogeräte für Gesundheit',
	'Elektrohändler',
	'Elektroindustrie-Unternehmen',
	'Elektroinstallation',
	'Elektromotoren- und Antriebstechnik',
	'Elektronik-Großhändler',
	'Elektronische Bauteile',
	'Elektrorasierer',
	'Elektrotechnik',
	'Elektrotechnikanbieter',
	'E-Mail-Anbieter',
	'Energie-Contracting',
	'Energiedienstleister',
	'Energiegenossenschaften',
	'Energiehandel',
	'Energiespeicher',
	'Energietechnik',
	'Energieversorger',
  'Energieversorger (regional)',
  'Energieversorger (überregional)',
  'Energy Drinks',
	'Entsorgungs- und Recyclingunternehmen',
	'Erlebnisgeschenke',
	'Erneuerbare Energien',
	'Erste-Hilfe-Kurse',
	'E-Scooter',
	'E-Scootervermieter',
	'E-Sports-Veranstalter',
	'Eventagenturen',
	'Eventdienstleister',
	'Eventlocations',
	'Events',
	'Fachmärkte für Wand/Boden',
	'Fachverlage',
	'Facility Management Medizinbereich',
	'Facility Manager',
	'Fahrräder und Mountainbikes',
	'Fahrradhändler',
	'Fahrradvermieter',
	'Fahrradzubehör',
	'Fahrschulen',
	'Fahrsicherheitstraining',
	'Fahrzeugbauer',
  'Fahrzeugteilehändler',
	'Familienheim',
	'Family Offices',
	'Farben und Lacke',
	'FDP',
	'Feinkosthändler',
	'Feinkostproduzenten',
	'Feinmechanik und Optikanbieter',
	'Ferienparks',
	'Ferienhausportale',
	'Fernbus-Anbieter',
	'Fernseher und Heimkino',
	'Fertiggaragen',
	'Fertiggerichte',
	'Fertighaus-Anbieter',
  'Fertigprodukte',
	'Finanz- und Anlageberatung',
	'Finanz- und Versicherungsmakler',
	'Finanzberater',
	'Finanzdienstleister',
	'Finanzen',
	'Finanzvertriebe',
	'Fintechs',
	'Fischwaren',
	'Fitnessgerätehändler',
	'Fitnessstudios',
	'Fleischereien',
	'Fleischer-Einkaufsgenossenschaften',
	'Fleischwaren',
	'Fliesen und Keramik',
	'Flugzeugteile',
  'Fluggastrechtportale',
	'Fluggesellschaften',
	'Flughäfen',
	'Flughafendienstleister',
	'Flugschulen',
	'Flugsicherungen',
  'Flugtaxis',
	'Flugzeugbauer',
	'Flusskreuzfahrten',
	'Fondsanlagegesellschaften',
	'Forderungsmanagement und Bonitätsprüfung',
	'Forschung und Entwicklung',
	'Forschungsinstitut für Ingenieurwissenschaften',
	'Forschungsinstitut für Medizin',
	'Forst- und Weidegenossenschaften',
	'Forstwirtschaft',
	'Fotodienste',
	'Fotogeschenke-Shops',
	'Fotoprodukte',
	'Frachtfluggesellschaften',
	'Fraktionslose',
	'Freie Wähler',
	'Freizeitattraktionen',
	'Freizeitbäder und Thermen',
	'Freizeitgeräte',
	'Friseure und Haarcenter',
	'Früchte',
	'Fruchtgummis',
  'Fruchtsäfte',
	'Fruchtsäfte und Nektare',
	'Fuhrparkmanagement',
	'Futtermittel',
	'FWG',
	'FWV',
	'Gardinen und Stoffe',
	'Gartenartikel-Shops',
	'Gartenbau',
	'Garteneinrichtungen',
	'Gartengeräte',
	'Gartenmärkte',
	'Gartenmöbel',
	'Gartenpflege',
	'Gashersteller',
	'Gasspeicher',
	'Gastronomie',
	'Gastronomiebetriebe',
	'Gebäude- und Klimatisierungstechnik',
	'Gebäude- und Klimatisierungstechnikanbieter',
	'Gebäudereinigungs- und Sicherheitsdienste',
	'Gebäudereinigungsdienste',
	'Gebäudesanierung',
	'Gebäudetechnik',
	'Gemeinnützige Krankenhäuser',
	'Gemischtwaren-Einzelhandel',
	'Genossenschaften',
	'Genossenschaften, Verbände und Vereine',
	'Genossenschaftsbanken',
	'Genusshändler',
	'Gerberei',
	'Geschenkartikel',
	'Geschenkshops',
	'Geschirr-, Glas- und Porzellanwaren',
	'Gesetzliche Krankenversicherungen',
	'Gesichtspflege und Kosmetik',
	'Gesundheitsartikel-Shops',
	'Gesundheitsdienste',
	'Gesundheitsprodukte & Nahrungsergänzungsmittel',
	'Getränkemärkte',
	'Gewerbe-Energieversorger',
	'Gewürze und Gewürzsaucen',
	'Gießerei',
	'Gießereien',
	'Glasverarbeitende Unternehmen',
	'Gold- und Edelmetallhändler',
	'Golfplätze',
	'Grills und Grillartikel',
	'Großhändler',
	'Großhändler für Agrarprodukte',
	'Großhändler für Baustoffe und Bauzubehör',
	'Großhändler für Lebensmittel und Getränke',
	'Großhändler für Pharmazie und Medizintechnik',
	'Großhändler für Stahl und Metalle',
	'Großhändler für technische und chemische Produkte',
	'Grundlagenforschungsinstitut',
	'Grundnahrungsmittel',
  'Grüne',
	'Gummi- und Kunststoffindustrieunternehmen',
	'Haarpflege',
	'Haarpflegeprodukte',
	'Hafendienstleister',
  'Halbleiter',
  'Hallen und Zelte',
  'Hardware-Hersteller',
	'Fahrzeugteilehändler',
	'Handtücher und Badtextilien',
	'Haushaltsartikel',
	'Haushaltselektrogeräte',
	'Hausnotrufsysteme',
	'Haus- & Sicherheitstechnik-Shops',
	'Heimdekoration',
	'Heimtextilien- und Bettwarenhändler',
	'Heimtierbedarf',
  'Heissgetränke',
	'Heißluftballons',
  'Heiz und Klimatechnik',
  'Heiztechnik',
	'Herrenbekleidung',
	'Hersteller keramischer Produkte',
	'Hersteller von medizinischen Hilfsmitteln',
	'Hochseekreuzfahrten',
	'Holdings',
	'Holzhäuser',
	'Holzverarbeiter',
	'Hörgeräte',
	'Hotels',
	'Hubschrauberunternehmen',
	'Im- und Exportunternehmen',
	'Immobilienbranche',
	'Immobilienentwickler',
	'Immobilieninvestmentgesellschaften',
	'Immobilienmakler',
	'Immobilienmanagement',
  'Immobilienrente',
	'Immobilienunternehmen',
	'Industriedienstleister',
	'Industriezulieferer',
	'Infrastrukturbauer',
	'Ingenieurbüros',
	'Ingenieurdienstleister',
	'Institutionen',
	'Insurtechs',
	'Internate',
	'Inventur',
	'Investmentgesellschaften',
	'IT- und Kommunikationsdienstleister',
	'IT-Berater',
	'IT-Dienstleister',
	'IT-Dienstleister im Medizinbereich',
	'IT-Dienstleistung für Rechtsdienstleistungen',
	'IT-Dienstleistung im Finanzdienstleitser',
	'IT-Security',
  'IT-Systemhäuser',
	'Jeans-Marken',
	'Kabelanschluss TV',
	'Kaffeeröster',
	'Kaffees',
	'Kakaos und Getränkepulver',
	'Kameras, Ferngläser und Zubehör',
	'Karten- und Geschenkpapier',
  'Käse',
	'Käsemarken',
	'Kategorie DAX Vorstände',
  'Katzenstreu',
	'Kaufhäuser',
	'Kaugummi',
	'Kerzen',
	'Kinder- und Jugendzimmermöbel',
	'Kinderkliniken (gemeinnützig)',
	'Kinderkliniken (öffentlich)',
	'Kinderkliniken (privat)',
	'Kinderschuhe und -kleidung',
	'Kindertagesstätten',
	'Kinderwagen und -sitze',
	'Kinos',
	'Kioske',
	'Kirchliche Hochschulen',
	'Kläranlagen',
	'Klebstoffe und Dichtmittel',
  'Klima Wärmepumpe',
	'Kliniken für Psychatrie und Neurologie (gemeinnützig)',
	'Kliniken für Psychatrie und Neurologie (öffentlich)',
	'Kliniken für Psychatrie und Neurologie (privat)',
	'Klinikverbunde (gemeinnützig)',
	'Klinikverbunde (öffentlich)',
	'Klinikverbunde (privat)',
	'Kochboxen',
	'Kommunale Entsorger',
	'Kommunale Ver- und Entsorger',
	'Kommunale Versorgungs- und Verkehrsgesellschaften',
	'Kommunale Wasserversorger',
	'Kommunikationsdienstleister',
	'Kondome',
	'Konfessionelle Banken',
	'Konfessionelle Krankenhäuser',
  'Konfitüren',
	'Konserven',
	'Konsolen- und PC-Spiele',
	'Kontaktlinsenversandhändler',
	'Konzert-, Musical- und Eventanbieter',
	'Kopfhörer und Mikrofone',
	'Körper- und Intimhygiene',
	'Körperpflege',
  'Kosmetik',
	'Kostümshop',
	'Kraftstoffe',
	'Kraftwerke',
	'Krankenhäuser',
	'Kreativwirtschaft',
  'Kreditbanken',
	'Kreditkarten',
	'Kreditplattformen',
	'Kreditvergebende Institute',
	'Küchenbedarf',
	'Kücheneinrichter',
	'Küchenmöbel',
	'Labordiagnostiker',
	'Laborunternehmen',
	'Ladestationen',
	'Lagereien',
	'Lampen und Leuchten',
	'Lampen-Shops',
	'Landes- und Förderbanken',
	'Landwirtschaft',
	'Lautsprecher',
	'Leasinggesellschaften',
	'Lebensmittel',
	'Lebensmitteleinzelhandel',
	'Lebensmittel-Lieferdienste',
  'Lebensmittelproduktion',
	'Lebensmittelproduzenten',
	'Lederwaren',
	'Leitsysteme und Schilder',
	'Lernplattformen',
	'Lichttechnik',
	'Lieferservices',
  'Limonaden',
	'Lkw und Nutzfahrzeuge',
	'Logistikgenossenschaften',
	'Logistikunternehmen',
	'Lohnsteuerhilfevereine',
	'Lotteriegesellschaften',
	'Lotterievermittler',
	'Luftbefeuchter',
	'Luftfahrt',
	'Luxusmarken',
	'Makler',
	'Maschinen- und Anlagenbau',
	'Maschinen- und Anlagenbauunternehmen',
	'Maßbekleidung',
	'Massivhaus-Anbieter',
	'Materialforschungsinstitut',
	'Matratzen',
	'Medienunternehmen',
	'Medizinische Hilfsmittel bei Inkontinenz und Stoma',
	'Medizinische Versorgungszentren und Arztpraxen',
	'Medizintechnik für den Büroalltag',
	'Medizintechnik für Hörgeschädigte',
	'Medizintechnik für Sehbehinderte',
	'Medizintechnikunternehmen',
	'Messen',
	'Messestandort',
	'Messtechnikanbieter',
	'Meta-Genossenschaften',
	'Metallkonstruktionshersteller',
	'Metallverarbeitung',
	'Metallwarenproduzenten',
  'Milch',
	'Milchprodukte',
	'Mineralölhändler',
  'Mineralwasser',
	'Mineralwässer und Erfrischungsgetränke',
	'Mitfahrzentralen',
  'Möbelhändler (online)',
	'Möbelhersteller',
	'Möbel nach Maß',
	'Möbelzubehör',
	'Mobilfunkanbieter',
	'Mobilfunk-Reseller',
	'Mobilitätshilfen-Hersteller',
	'Mobiltelefone',
	'Mode- und Textilhäuser',
	'Modeanbieter',
	'Modelabels',
  'Modehändler (online)',
	'Modeunternehmen',
	'Molkereigenossenschaften',
	'Montagesysteme',
	'Motorräder und Mopeds',
	'Mundpflege',
	'Münzen, Banknoten und Medaillen',
	'Musik- und Tanzschulen',
	'Musikindustrie',
	'Musikinstrumente',
	'Musikinstrumentengeschäfte',
	'Musiklabels',
	'Musik-Streamingdienste',
	'Musikverlage',
	'Müsli und Frühstücksprodukte',
	'Nachhilfeinstitute',
	'Nagelstudios',
	'Nahrungsergänzungsmittel und Vitaminpräparate',
	'Naturwissenschaftliche Forschung',
	'Navigationssysteme',
	'Navigationstechnologie',
	'Netzbetreiber',
	'NGO',
	'Nutzfahrzeughändler',
	'Oberflächen- und Materialbearbeitung',
	'ÖDP',
	'Öffentlicher Dienst',
  'Öffentliche Krankenhäuser',
	'Öko-Strom-Anbieter',
	'Online-Baumärkte',
	'Online-Bezahldienste',
	'Online-Broker',
	'Online-Buchhändler',
	'Online-Bürobedarfshändler',
	'Online-Dienstleistungen',
	'Online-Elektronikhändler',
	'Onlinehändler für medizinische Produkte',
	'Online-Jobportale',
	'Online-Matratzenhändler',
	'Online-Möbelhäuser',
	'Online-Modehändler',
	'Online-Optiker',
	'Online-Partnervermittler',
	'Online-Reifenhändler',
	'Online-Shops (Generalisten)',
	'Online-Vergleichsportale',
	'Online-Versandhändler',
	'Optiker',
	'Optikprodukt-Herstelller',
	'Orgelbauer',
	'Orthopädietechniker',
	'Orthopädische Kliniken (gemeinnützig)',
	'Orthopädische Kliniken (öffentlich)',
	'Orthopädische Kliniken (privat)',
	'Outdoor- und Freizeitequipment',
	'Outlets',
  'Ökostrom- & Gasanbieter',
	'Papierverarbeiter',
	'Parfümerien',
	'Parfüms und Düfte',
	'Parkhausbetreiber',
	'Parteilose',
	'Peripheriegeräte',
	'Personalberater und -vermittler',
	'Personaldienstleister',
	'Pflanzenversender',
	'Pflegeimmobilien',
	'Pflege- und Gesundheitsprodukte',
	'Pflege- und Hilfsdienste',
	'Pflege- und Seniorenheime',
	'Pflegebetten-Hersteller',
	'Pflege-Hebesysteme',
	'Pharmaunternehmen',
  'pikante Brotaufstriche',
	'Piratenpartei',
	'Pkw',
	'Politiker',
	'Polstermöbelspezialisten',
	'Polster und Kissen',
	'Pool-Shops',
	'Pool- und Schwimmbadbauer',
	'Portale für Putz- und Haushaltshilfen',
	'Portale, Communities und Suchmaschinen',
	'Post- und Kurierdienste',
	'Preissuchmaschinen',
	'Privatbanken',
	'Private Hochschulen',
	'Private Krankenhäuser',
	'Private Krankenversicherungen',
	'Probiotica',
	'Produzierendes Gewerbe',
	'Prüfgesellschaften',
	'PSD Banken',
	'Putz-, Pflege- und Waschmittel',
	'Quadrokopter',
	'Rabatte und Gutscheine',
	'Raffination und Rohstoffgewinnung',
	'Raiffeisen-Bezugs-/Waren-/Handelsgenossenschaften',
	'Rasierer',
	'Rauchtabak, Zigaretten, Zigarren und Zigarillos',
	'Raumausstattung',
	'Raumausstattungsgeschäfte',
	'Rechtsanwälte und Wirtschaftsprüfer',
	'Rechtsberatung - online',
	'Rechtsdienstleistungen und -Anwälte',
	'Re-Commerce',
	'Reedereien',
	'Regional- und Nahverkehr',
	'Regionale Energieversorger',
	'Regionale Gasversorger',
	'Regionale Krankenhäuser',
	'Reha-Kliniken',
	'Autoreifen',
	'Reifenhändler',
  'Reifenhändler - online',
	'Reisebüros',
	'Reiseführer',
	'Reiseportale',
	'Reiseveranstalter',
	'Reitsporthändler',
  'Reparatur-Dienstleister',
	'Rettungsdienste',
	'Rohrbauer',
	'Rohstoffe',
	'Rundfunkveranstalter',
	'Rüstungsunternehmen',
	'Salz-und Käsegebäcke',
	'Sanitär',
	'Sanitärarmaturen',
	'Sanitätshäuser',
	'Sauerstoffgeräte',
  'Schadensdienstleister',
  'Schädlingsbekämpfer',
	'Schädlingsbekämpfungsmittel',
	'Schalt- und Verbindungstechnik',
	'Schienenfahrzeugbauer',
	'Schiffslinien und -touristik',
	'Schirme',
	'Schlafzimmermöbel',
	'Schleifmittel',
	'Schmierstoffhersteller',
	'Schmuck',
	'Schokolade, Nougat oder Marzipan',
	'Schreibgeräte',
	'Schuhe',
	'Schuhhändler',
	'Schulen',
	'Schwimmschulen',
	'Segelschule',
	'Seilbahnen',
	'Sektmarken',
	'Self-Storage-Anbieter',
	'Service-Dienstleister',
	'Shopping-Clubs',
	'Sicherheitsdienste',
	'Sicherheitstechnik',
	'Sicherungs- und Warngeräte',
	'Sitzmöbel und Tische',
	'Skihallen',
	'Skischule',
	'Skulptur-Gießereine',
	'Smart Home Lösungen',
	'Smarte Technik für Selbstbestimmheit',
	'Social Media',
	'Softdrinks',
	'Software für Videosprechstunden',
	'Software- und Hardwareentwickler',
	'Softwareunternehmen',
	'Solartechnik',
	'Sonderpostenmärkte',
	'Sonnenschutz',
	'Sonnenstudios',
	'Sozial- und Gesundheitsunternehmen',
	'Soziale Arbeit',
	'Soziale Dienste',
	'Sozialversicherung',
	'Sparda-Banken',
	'Sparkassen',
	'SPD',
	'Speisefette und -öle',
	'Spezialbanken',
	'Spezialchemieunternehmen',
	'Spezialkliniken (gemeinnützig)',
	'Spezialkliniken (öffentlich)',
	'Spezialkliniken (privat)',
	'Spielautomaten',
	'Spielbanken',
	'Spielwarengeschäfte',
	'Spielzeuge',
	'Spirituosen',
	'Sport- und Camping-Onlineshops',
	'Sport- und Freizeitbekleidung',
	'Sportartikelhersteller',
	'Sportgeschäfte',
	'Sportlernahrung',
	'Sportnahrungs-Shops',
	'Sportvereine',
	'Sportwaffen',
	'Sprachkurse - online',
	'Sprachschulen',
	'SSW',
	'Staatliche Hochschulen',
	'Städtische Kliniken',
	'Stadtmarketing',
	'Stadtplanung und -entwicklung',
	'Stadtwerke',
	'Stahlunternehmen',
	'Stahlwerke',
	'Steakhäuser',
	'Stellenvermittlungsagenturen',
	'Steuersoftware',
	'Streamingdienste',
	'Strom- und Gasnetzbetreiber',
	'Supermärkte',
	'Süßgebäcke',
	'Süßwaren',
	'Systemgastronomie',
	'Tabak- und Zigarrengeschäfte',
	'Tabakwaren',
	'Tabakwarenhersteller',
	'Tankstellen',
	'Tapeten',
	'Taschen und Koffer',
	'Taxis',
	'Technische Dienstleister',
	'Technische Komponentenhersteller',
	'Tees',
	'Telekommunikationsanbieter',
	'Teppiche und Bodenbeläge',
	'Textilbranche',
	'Textil-Einzelhändler',
	'Textilhersteller',
	'Textilvermieter',
	'Theater und Konzerthäuser',
	'Themen- und Freizeitparks',
	'Ticketshops',
	'Tiefkühlkost',
	'Tiernahrung',
	'Tierschutzpartei',
	'Touristik',
	'Transfergesellschaften',
	'Treppenhersteller',
	'Treppenlifte',
	'Tür- und Fenstertechnik',
	'TV-Empfangsanlagen und Antennen',
	'Überregionale Energieversorger',
	'Übersetzungen',
	'Übersetzungsbüros/Sprachdienstleister',
	'Uhren',
	'Uhren-Shops',
	'Uhren und Schmuck',
	'Uhren- und Schmuckgeschäfte',
  'Umwelttechnik',
  'Umzugsunternehmen',
	'Universalbanken',
	'Universitätskliniken',
	'Unterhaltungselektronik',
	'Unternehmensberater',
	'Unterstützung für behinderte Menschen',
	'Unterstützung für Benachteiligte',
	'Unterstützung für Kinder und Jugendliche',
	'Urlaub und Freizeit',
	'Vergleichsportale',
	'Ver- und Entsorger',
	'Veranstalter',
	'Verkehr und Logistik',
	'Verkehr und Transport',
	'Verkehrsgastronomie',
	'Verlage',
	'Vermieter von Maschinen und Geräten',
	'Vermögensverwalter',
	'Verpackungshersteller',
	'Verpackungsunternehmen',
	'Versand- und Online-Handel',
	'Versandapotheken',
	'Versicherungen',
	'Versicherungsmakler',
	'Volks- und Raiffeisenbanken',
	'Volkshochschulen',
	'VOLT',
	'Waffen',
	'Wärme- und Kältetechnik',
	'Wäsche',
	'Wäschedienste',
	'Wasserfahrzeuge und Werften',
	'Wassergenossenschaften',
	'Wassersport',
	'Wasserwerke',
	'Wechselportale',
	'Weidegenossenschaften',
	'Weinbau',
	'Weine',
	'Weinhändler',
	'Weiterbildungsanbieter',
	'Werbe- und Pr-Agenturen',
	'Werbeartikel',
	'Werkstätten',
	'Werkzeuge und Geräte',
	'Wettbüros',
	'Wettgesellschaften',
	'Wichtige Persönlichkeiten',
	'Wind- und Solartechnik',
	'Windkraftanlagen',
	'Windkraftanlagenproduzenten',
	'Wirtschaftsdetekteien',
	'Wirtschaftsprüfer und Steuerberater',
	'Wohngenossenschaften',
	'Wohnungsbau',
	'Wohnungsunternehmen',
	'Wohnwagen und Reisemobile',
	'Wohnzimmermöbel',
  'Wurst',
	'Zahlungsdienstleister',
	'Zahnschienen',
	'Zeitarbeitsvermittler',
	'Zeitschriften',
	'Zertifizierer',
	'Zigarettenmarke',
	'Zigarren',
	'Zoogeschäfte',
	'Zoos',
	'Zuckerhersteller',
  'Zulieferer',
	'Zustellgesellschaften',
	'ZZ-Arbeitsplatzbau/Ladenbau',
	'ZZ-Ortsangabe fehlt',
	'ZZ-Raus',
	'ZZ-Raus- Bowlingcenter',
	'ZZ-Testentität',
	'ZZ-Zuordnen'
],
INDUSTRIES_AUSTRIA : [
	'Accessoires',
	'Agrar',
	'Agrarprodukte',
  'Akademie',
  'Aktionsmarkt',
  'Akustik',
  'Amt',
	'Anlagen',
  'Anlagenbau',
  'Apotheke',
  'Arch+Ing',
	'Attraktion',
	'Auktionen',
  'Außenstelle',
  'Autobahnraststätte',
  'Autohaus',
  'Automatisierung',
  'Automotive',
  'Automotive/Zulieferindustrie',
  'Autopflege',
  'Autoreparatur',
  'Autovermietung',
  'Autowäsche',
  'Bäcker',
	'Bank',
	'Bau',
	'Baumarkt',
  'Baumarkt und Gartencenter',
	'Bausparkasse',
  'Bauunternehmen',
  'Bau-Zulieferer',
  'Bekleidung',
  'Bekleidung - Schuhhandel',
	'Bestattung',
  'BGLD',
  'Bier',
	'Bildung',
	'Biotech',
  'BGM',
  'Blumen',
	'Brot',
  'Buch und Papierhandel',
  'Bund',
  'Bundesanstalt',
	'Chemie',
  'Club',
	'Consulting',
	'Dienstleister',
  'Dienstleistung',
  'Diskont-Supermarkt',
	'Drogerie',
	'Druck',
  'Einkaufszentrum',
  'Elektro',
  'Elektrohandel',
  'Elektromarkt',
	'Elektronik',
	'Energie',
	'Entsorgung',
  'Essenslieferant',
	'Event',
  'Fahrradhandel',
  'Fachhochschule',
	'FacilityMgmt',
  'Feinkost',
	'Fertighäuser',
  'Festival',
	'Finanz',
	'FinTech',
	'Fitness',
	'Fleisch',
	'Forschung',
  'FPÖ',
	'Freizeit',
	'Frisör',
	'Gastronomie',
	'Gebäude',
	'Gebäudeausstattung',
	'Gebäudetechnik',
  'Generalist',
	'Gesundheit',
	'Getränke',
  'Gewerkschaft',
	'Glas',
  'Glas & Keramik',
	'Glückspiel',
	'Großhandel',
	'Grundnahrungsmittel',
  'Grundstoffindustrie',
  'GRÜNE',
	'Handel',
  'Haus und Garten',
  'Haushalt',
  'Hochschule',
  'Holding',
	'Holz',
  'Holzindustrie',
  'Holzverarbeiter',
	'Hotel',
	'Hygiene',
  'IKG',
	'Immobilien',
	'Immobilienentwickler',
	'Immobilienmakler',
  'Immobilienverwaltung',
  'Immoprojekt',
	'Industrie',
	'Infrastruktur',
	'Institution',
	'Instrumente',
	'Internet',
  'ISP',
	'IT',
  'Justiz',
  'Kammer',
	'Keramik',
	'KFZ',
  'Kirchliche Hochschule',
  'Klassische Musik',
	'Konserven',
	'Kosmetik',
  'KPÖ',
	'Krankenhaus',
  'KNT',
  'KSW',
	'Kultur',
	'Kunststoff',
  'Küchen',
	'Leasing',
	'Lebensmittel',
  'Lebensmittel - Spezialhandel',
	'Licht',
  'Limonade',
	'Logistik',
	'Luftfahrt',
  'Luxus',
	'Makler',
	'Marke',
	'Maschinen',
  'Maschinenbau',
  'Matratzen und Heimtextilien',
  'Medien',
	'Medizintechnik',
	'Metall',
  'Metallbearbeitungsindustrie',
  'MFG',
	'Milchprodukte',
  'Ministerium',
  'Mischkonzern',
  'Modehandel',
  'Modemarke',
	'Möbel',
  'Möbel und Einrichtung',
  'Museum',
  'Nachhilfe',
  'Neos',
	'Netze',
	'NGO',
	'NoAG',
  'NPO',
  'NÖ',
  'Obst&Gemüse',
  'OEPAK',
	'Optik&Akustik',
  'OÖ',
  'ÖAK',
  'ÖÄpK',
  'ÖGB',
  'ÖLAKT',
  'ÖNK',
  'Online',
  'ÖVP',
  'ÖZAK',
	'Papier',
  'Partei',
  'Pädagogische Hochschule',
  'Person',
	'Personal',
	'Personenverkehr',
	'Pflanzen',
	'Pharma',
	'Politik',
  'Politiker',
  'Private Hochschule',
  'Projekt',
  'RAK',
  'Regionalbank',
  'Reinigung',
	'Reisen',
  'Religion',
	'Rohstoffe',
  'Rundfunk',
  'Saft',
  'SBG',
	'Schloss',
  'Schuhhandel',
  'Seilbahnen',
  'Sexshop',
	'Sicherheit',
	'Skigebiet',
  'Software',
	'Solar',
	'Soziales',
	'Sozialpartner',
	'Sozialversicherung',
  'Spedition',
	'Spezial',
	'Spielzeug',
	'Sport',
  'SPÖ',
	'Staat',
  'Staatliche Hochschule',
	'Stadtwerke',
  'Stift',
  'STMK',
  'Supermarkt',
	'Süsswaren',
	'Süßwaren',
  'Tabak',
  'Tankstelle',
  'TEAM',
	'Telekom',
	'Textil',
  'Theater',
  'THEMA',
	'Therme',
	'Tiefkühlware',
	'Tierbedarf',
  'Tirol',
  'Tourismus',
	'Transport',
	'Türen&Fenster',
  'Universität',
	'Verband',
  'Verein',
	'Verlag',
	'Verpackungen',
	'Versicherung',
  'Verwaltung',
  'VETAK',
  'VLBG',
	'Vorsorgekasse',
	'Waffen',
	'Werkstoffe',
  'Werkzeuge',
  'Wien',
  'Windkraft',
  'WK',
	'Zahlungen',
	'Zentrum',
  'Zulieferer'
],
INDUSTRIES_SWITZERLAND: [
	'Mischkonzern',
	'Mineralölhandel',
	'Bank - Kantonalbanken',
	'Maschinenindustrie',
	'Computer/Informatik',
	'Chemie/Pharma',
	'Dienstleistungen',
	'Metallverarbeitung',
	'Fahrzeug-/Karosseriebau',
	'Gesundheitswesen',
	'Energieversorgung/-verteilung',
	'Elektronik/Elektrotechnik',
	'Medizinaltechnik',
	'Detailhandel',
	'Immobilien/GU/Dienstleistungen',
	'Unternehmensberatung',
	'Versicherung',
	'Verpackung',
	'Automobilhandel/-import',
	'Welthandel/Rohstoffhandel',
	'Grosshandel (Fahrzeugbranche)',
	'Grosshandel (Non Food)',
	'Bauunternehmen',
	'Aussenwerbung',
	'Bauzulieferer/Bauelemente',
	'Farbstoffe/Spezialchemie',
	'Nahrungsmittel',
	'Logistik/Spedition',
	'Krankenkasse',
	'Uhrenindustrie',
	'Graphisches Gewerbe/Verlage',
	'Bank - Andere Banken',
	'Bank - Auf Börsen, Effekten-, Vermögensverw.-Geschäfte spez. Institute',
	'Bank - Ausländisch beherrschte Banken',
	'Schokoladeindustrie',
	'Bahnen/Öffentlicher Verkehr',
	'Wirtschaftsprüfung',
	'Drogerien/Parfümerien/Apotheken',
	'Konsumgüter',
	'Haustechnik/Gebäudeautomation',
	'Fleischverarbeitung',
	'Elektroapparate/Haushaltgeräte',
	'Gütertransporte/Terminals',
	'Gastgewerbe/Restaurants',
	'Investment',
	'Befestigungstechnik',
	'Online Handel',
	'Tabak',
	'Draht/Kabel/Gummi/Maschinen',
	'Elektroanlagen',
	'Detailhandel (Bekleidung)',
	'Bekleidungsindustrie',
	'Telecom',
	'Getränke/Brauereien/Spirituosen',
	'Papier-/Kartonindustrie',
	'Bank - Regionalbanken und Sparkassen',
	'Möbel/Inneneinrichtung',
	'Kosmetik/Körperpflege',
	'Bank - Grossbanken',
	'Metall-/Stahlhandel',
	'Multimeda/Fachmärkte',
	'Schuhproduktion/-handel',
	'Ingenieurunternehmen',
	'Gastronomie/Catering',
	'Grosshandel (Elektronik)',
	'Mess- und Regeltechnik',
	'Facility Management',
	'Bergbau/Erdgas/Dünger',
	'Förder- und Lagertechnik',
	'Grosshandel (Food)',
	'Luftverkehr',
	'Teppiche/Bodenbeläge',
	'Gemeinschafts-Gastronomie/Catering',
	'Kunststofftechnologie',
	'Reiseunternehmen/Tourismus',
	'Uhren/Schmuck',
	'Diverse',
	'Sportartikel/-bekleidung',
	'Biologische Stoffe',
	'Detailhandel (Uhren/Schmuck)',
	'Unterhaltungselektronik',
	'Messegesellschaften',
	'Multimedia/Fachmärkte',
	'Grosshandel Chemie/Pharma',
	'Solartechnik',
	'Flugzeugteile',
	'Food',
	'Pharma',
	'Grosshandel (Chemie/Pharma)',
	'Tabakindustrie/-handel',
	'Hotellerie',
	'Logistik',
	'Bank - Banken mit besonderem Geschäftskreis',
	'Personalvermittlung',
	'Bahntechnik/Geleisebau',
	'Autozulieferer',
	'Medien',
	'Optiker',
	'Büroorganisation/-bedarf'
]
}
